const index = "role";

export const roleEndpoint = Object.freeze({
  role: index,
});
